import { Component, Input, forwardRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { RadioButtonOptionModel } from '../../../../../Common/Forms/models/radio-button-option.model';
import { AbstractFormFieldComponent } from '../../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { RadioButtonsFieldModel } from '../../../../../Common/PageBuilder/models/radio-buttons-field.model';

@Component({
    selector: 'agpr-radio-buttons-field',
    templateUrl: './radio-buttons-field.component.html',
    styleUrls: ['./radio-buttons-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => RadioButtonsFieldComponent)
        }
    ],
    standalone: false
})
export class RadioButtonsFieldComponent extends AbstractFormFieldComponent implements OnInit, OnChanges {
    @Input() declare field: RadioButtonsFieldModel;

    selectedOption: string = null;
    selectedSubOption: string = null;

    useChartPrefColors: boolean = false;
    showRadioButtons: boolean = true;

    constructor(protected localizationService: LocalizationService) {
        super();
    }

    ngOnInit(): void {
        this.useChartPrefColors = !!(this.field?.useChartPrefColors);

        this.setSelectedOption();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.field.appearCondition) {
            this.showRadioButtons = this.field.appearCondition(this.block.displayElement);
        }
        this.field.options.forEach(option => {
            if (option.enableCondition) {
                option.disabled = !option.enableCondition(this.block.displayElement);
            }
        });
    }

    onRadioButtonChanged(option?: RadioButtonOptionModel) {
        if (!this.selectedSubOption
            || (option?.subRadioOptions && option.subRadioOptions.filter(subOption => subOption.key === this.selectedSubOption).length === 0) ) {
            this.selectedSubOption = this.selectedOption;
        }

        this.value = option ? option.key : this.selectedSubOption;
        this.changes.emit(this.value);
    }

    setSelectedOption(): void {
        if (!this.field.options || this.field.options.length === 0) {
            return;
        }

        // if it has subOptions, compare the value with subOption, if not, compare with option
        this.field.options.forEach(option => {
            if (option.subRadioOptions && option.subRadioOptions.length > 0) {
                option.subRadioOptions.forEach(subOption => {
                    if (subOption.key === this.value) {
                        this.selectedOption = option.key;
                        this.selectedSubOption = subOption.key;
                    }
                });
            } else {
                if (option.key === this.value) {
                    this.selectedOption = option.key;
                }
            }
        });

        if (!this.selectedOption) {
            this.selectedOption = this.field.options[0].key;
            if (this.field.options[0].subRadioOptions && this.field.options[0].subRadioOptions.length > 0 ) {
                this.selectedSubOption = this.field.options[0].subRadioOptions[0].key;
            }

            this.value = this.selectedSubOption ? this.selectedSubOption : this.selectedOption;
            this.changes.emit(this.value);
        }
    }
}
